import { render } from "./ShopPosDetail.vue?vue&type=template&id=05e47a7c&scoped=true"
import script from "./ShopPosDetail.vue?vue&type=script&lang=js"
export * from "./ShopPosDetail.vue?vue&type=script&lang=js"

import "./ShopPosDetail.vue?vue&type=style&index=0&id=05e47a7c&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e47a7c"]])

export default __exports__